'use client';

import { type ShowType } from '@/features/products/types';
import { ToggleButton, ToggleButtonGroup } from '@andritzot/metris-web-ui/inputs/toggle-button';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type MouseEvent } from 'react';

interface ShowTypeSelectionProps {
  onChange: (value: ShowType[]) => void;
  showType: ShowType[];
}

const OPTIONS: ShowType[] = ['Show Components', 'Show Solutions'];

const ShowTypeSelection = ({ onChange, showType }: ShowTypeSelectionProps) => {
  const handleChange = (_e: MouseEvent<HTMLElement>, value: ShowType[]) => {
    onChange(value);
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', my: 1 }}>
      <ToggleButtonGroup
        value={showType}
        onChange={handleChange}
        size="small"
        fullWidth
        sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
      >
        {OPTIONS.map((option) => (
          <ToggleButton
            key={option}
            value={option}
            sx={{
              whiteSpace: 'normal',
              lineHeight: 1.2,
              py: 1,
              width: '100%',
              '&:hover': { backgroundColor: 'primary.50' },
              '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: '-2px' },
              '&.Mui-selected': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                '&:focus': { backgroundColor: 'primary.main', color: 'primary.contrastText' },
                '&:hover': { backgroundColor: 'primary.dark', color: 'primary.contrastText' },
              },
            }}
          >
            {option}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default ShowTypeSelection;
